import { h } from 'preact'
import tracker from '../../components/tracker/publish'
import Icon from "../assets";

type Props = {
    isPreviewPublic: boolean,
    privateId: number,
    title: string,
    url: string
}

const eventTracker = (props: Props) => {
    const user = window.inSidedData.user
    tracker.trackEvent('userevent', {
        'type': 'Article Previewed',
        'id': props.privateId,
        'url': props.url,
        'title': props.title,
        'userid': user.userid,
        'user_primary_role': user.mainRole,
        'user_custom_roles': user.role,
        'user_name': user.name,
        'user_email': user.email,
        'isPreviewPublic': props.isPreviewPublic
    })
}

const ArticlePreviewNotice = (props: Props) => {
    const notice_text = props.isPreviewPublic
        ? 'Anyone who has the link can access preview via the link without signing in'
        : 'Only people with moderator role or above can access this page via the link'

    eventTracker(props)

    return <div className="article_preview__notice">
        <div className="article_preview__notice_label h3">Article Preview</div>
        <div className="article_preview__notice_desc">
            <div className="article_preview__notice_icon">
                <Icon icon='people' height={16} width={15} color='#6B707E'/>
            </div>
            <div className="article_preview__notice_text">{ notice_text }</div>
        </div>
    </div>
}

export default ArticlePreviewNotice
